import React from 'react';
import { Tab } from 'semantic-ui-react';
import { Coupons, Competition, Common, Description, Price, Workshop } from './Panes';
import { generate } from 'shortid';
import { insert, clone } from 'ramda';

const CompetitionTab = (props) => {
  const { data, onChange, onToggle, onEventChange } = props;

  const commonPanes = [
    {
      menuItem: { key: generate(), icon: 'info circle', content: 'General' },
      render: () =>
        <Tab.Pane>
          <Common
            data={data}
            onChange={onChange}
            onToggle={onToggle}
            onEventChange={onEventChange}/>
        </Tab.Pane>
    },
    {
      menuItem: { key: generate(), icon: 'book', content: 'Description' },
      render: () =>
        <Tab.Pane>
          <Description data={data} onChange={onChange} onToggle={onToggle} />
        </Tab.Pane>
    },
    {
      menuItem: { key: generate(), icon: 'euro sign', content: 'Pricing' },
      render: () =>
        <Tab.Pane>
          <Price data={data.price} onChange={onChange} />
        </Tab.Pane>
    },
    {
      menuItem: { key: generate(), icon: 'tags', content: 'Coupons' },
      render: () =>
        <Tab.Pane>
          <Coupons data={data.coupons} onChange={onChange} />
        </Tab.Pane>
    }
  ];

  let panes;

  if (data.event) {
    if (data.event.type === 'COMPETITION') {
      panes = insert(2, {
        menuItem: { key: generate(), icon: 'trophy', content: 'Competition' },
        render: () =>
          <Tab.Pane>
            <Competition data={data} onChange={onChange} onToggle={onToggle} />
          </Tab.Pane>
      }, commonPanes);
    } else if (data.event.type === 'WORKSHOP') {
      panes = insert(2, {
        menuItem: { key: generate(), icon: 'wrench', content: 'Workshop' },
        render: () =>
          <Tab.Pane>
            <Workshop data={data} onChange={onChange} />
          </Tab.Pane>
      }, commonPanes);
    }
  }

  return <Tab panes={panes || clone(commonPanes)} />;
};

export default CompetitionTab;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Tab.js